import { useEffect, useState, useCallback } from 'react';
import { getSession } from './auth';

// Hook réactif à l'état de session — re-render quand setSession/clearSession
// sont appelés (event 'cb:session-changed' émis depuis ./auth).

export default function useSession() {
  const [session, setSessionState] = useState(() => getSession());

  const refresh = useCallback(() => setSessionState(getSession()), []);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === 'cb_auth') refresh(); };
    window.addEventListener('cb:session-changed', refresh);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('cb:session-changed', refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, [refresh]);

  return session;
}
